import MainLayout from '@theme/components/MainLayout';
import PostList from '@theme/components/PostList';
import Pagination from '@theme/components/Pagination';
import TagsBar from '@theme/components/TagsBar';
export default {
  data() {
    return {
      tag: '',
      total: 0,
      // 总长
      perPage: 10,
      // 每页长
      currentPage: 1 // 当前页
    };
  },
  components: {
    MainLayout,
    PostList,
    Pagination,
    TagsBar
  },
  mounted() {
    const queryTag = this.$route.query.tag;
    if (queryTag) {
      this.tag = queryTag;
      this.total = this.$groupPosts.tags[queryTag].length;
    } else {
      this.total = this.$sortPosts.length;
    }
    if (this.$route.query.p) {
      this.currentPage = Number(this.$route.query.p);
    }
  },
  methods: {
    handlePagination(i) {
      // 分页
      this.currentPage = i;
    }
  },
  watch: {
    '$route.query.tag'(tag) {
      this.tag = tag ? decodeURIComponent(tag) : '';
      if (this.tag) {
        this.total = this.$groupPosts.tags[this.tag].length;
      } else {
        this.total = this.$sortPosts.length;
      }
      this.currentPage = 1;
    }
  }
};